

// import React, { useEffect, useState } from 'react';
// import { useParams, useHistory } from 'react-router-dom';
// import { 
//   Box, 
//   Typography, 
//   Button, 
//   Chip, 
//   TableCell, 
//   TableContainer, 
//   TableHead, 
//   TableRow,
//   Table,
//   TableBody,
//   CircularProgress,
//   IconButton,
//   Alert,
//   Snackbar,
//   Collapse,
//   Card,
//   CardHeader,
//   CardContent,
//   Tooltip
// } from '@mui/material';
// import ArrowBackIcon from '@mui/icons-material/ArrowBack';
// import DownloadIcon from '@mui/icons-material/Download';
// import InfoIcon from '@mui/icons-material/Info';
// import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
// import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
// import axios from 'axios';
// import { MapView } from './DataDelivery-map-components';
// import { TableRowImage, prefetchPreviews,formatDate, formatEstimatedTime,getPreviewUrl } from './DataDelivery-services-utils';
// import VisibilityIcon from '@mui/icons-material/Visibility';
// import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
// import LayersIcon from '@mui/icons-material/Layers';
// import { CATALOG_URLS, IMAGE_URLS } from '../config/urls';


// const DataDeliveryPage = () => {
//     const { orderId } = useParams();
//     const history = useHistory();
//     const [orderData, setOrderData] = useState(null);
//     const [isLoading, setIsLoading] = useState(true);
//     const [activeMapType, setActiveMapType] = useState('street');
//     const [error, setError] = useState(null);
//     const [snackbar, setSnackbar] = useState({
//       open: false,
//       message: '',
//       severity: 'info'
//     });
//     // State to track which constellation groups are expanded
//     const [expandedGroups, setExpandedGroups] = useState({});
  
//     // Helper to transform selected images for the table and group by constellation
//     const getGroupedData = () => {
//       const tableData = orderData?.selected_images || [];
      
//       // Group images by satellite/constellation
//       return tableData.reduce((acc, image) => {
//         const constellation = image.satellite || 'Unknown';
//         if (!acc[constellation]) {
//           acc[constellation] = [];
//         }
//         acc[constellation].push(image);
//         return acc;
//       }, {});
//     };
  
//     // Compute the group data
//     const groupedData = orderData ? getGroupedData() : {};
  
//     // Initialize expanded groups when order data changes
//     useEffect(() => {
//       if (orderData?.selected_images?.length) {
//         const constellations = {};
//         orderData.selected_images.forEach(image => {
//           const constellation = image.satellite || 'Unknown';
//           constellations[constellation] = true; // Set all to expanded by default
//         });
        
//         if (Object.keys(constellations).length > 0) {
//           setExpandedGroups(constellations);
//         }
        
//         // Pre-fetch all preview URLs for better user experience
//         if (orderData.order_type === 'archival') {
//           const imageIds = orderData.selected_images.map(img => img.id);
//           // prefetchPreviews(imageIds).catch(err => console.error("Error pre-fetching previews:", err));
//         }
//       }
//     }, [orderData]);
  
//     useEffect(() => {
//       const fetchOrderDetails = async () => {
//         try {
//           if (!orderId) {
//             throw new Error('No order ID provided');
//           }
          
//           try {
//             // Always use real API call to get the actual data
//             const token = localStorage.getItem('token');
//             const response = await axios.get(CATALOG_URLS.getOrder(orderId), {
//               headers: { Authorization: `Bearer ${token}` }
//             });
            
//             // console.log("Fetched order data:", response.data); // Debug log
//             setOrderData(response.data);
//           } catch (error) {
//             console.error("Error fetching order data:", error);
//             setError(`Failed to fetch order data: ${error.message}`);
//             setSnackbar({
//               open: true,
//               message: `Error: ${error.message}`,
//               severity: 'error'
//             });
//           } finally {
//             setIsLoading(false);
//           }
//         } catch (error) {
//           console.error('Error fetching order details:', error);
//           history.replace('/orders');
//         }
//       };
  
//       fetchOrderDetails();
//     }, [orderId, history]);
  
//     // Function to determine the color for status chips
//     const getStatusColor = (status) => {
//       switch (status) {
//         case 'requested':
//           return { bg: '#DCF2FF', color: '#0288D1' };
//         case 'accepted':
//           return { bg: '#E3F3E3', color: '#4CAF50' };
//         case 'processing':
//           return { bg: '#FFF3E0', color: '#FF9800' };
//         case 'captured':
//           return { bg: '#E0E0E0', color: '#616161' };
//         case 'Delivered':
//           return { bg: '#E8EAF6', color: '#3F51B5' };
//         case 'rejected':
//           return { bg: '#FFEBEE', color: '#F44336' };
//         case 'on-hold':
//           return { bg: '#EDE7F6', color: '#673AB7' };
//         case 'failed':
//           return { bg: '#FFCDD2', color: '#D32F2F' };
//         default:
//           return { bg: '#F5F5F5', color: '#757575' };
//       }
//     };
  
//     // Get order status steps based on order type
//     const getOrderStatusSteps = () => {
//       if (orderData?.order_type === 'tasking') {
//         return ['requested', 'accepted', 'captured','processing', 'Delivered'];
//       } else {
//         // Default to archival
//         return ['requested', 'accepted', 'processing', 'Delivered'];
//       }
//     };
  
//     // Check if current status is a final status
//     const isFinalStatus = (status) => {
//       return ['Delivered', 'rejected', 'on-hold', 'failed'].includes(status);
//     };
  
//     // Get the current step index for the progress bar
//     const getCurrentStepIndex = () => {
//       const steps = getOrderStatusSteps();
//       const currentStatus = orderData?.status || 'requested';
      
//       // If current status is in the steps, return its index
//       const statusIndex = steps.indexOf(currentStatus);
//       if (statusIndex !== -1) {
//         return statusIndex;
//       }
      
//       // If it's a final status but not Delivered, show as last step with different color
//       if (isFinalStatus(currentStatus) && currentStatus !== 'Delivered') {
//         return steps.length - 1;
//       }
      
//       // Default to requested (first step)
//       return 0;
//     };
  
//     // Close snackbar
//     const handleCloseSnackbar = () => {
//       setSnackbar({...snackbar, open: false});
//     };
  
//     // Toggle expansion of a constellation group
//     const toggleGroupExpansion = (constellation) => {
//       setExpandedGroups(prevState => ({
//         ...prevState,
//         [constellation]: !prevState[constellation]
//       }));
//     };
  
//     if (isLoading) {
//       return (
//         <Box 
//           sx={{ 
//             display: 'flex', 
//             justifyContent: 'center', 
//             alignItems: 'center', 
//             height: '100vh' 
//           }}
//         >
//           <CircularProgress />
//         </Box>
//       );
//     }
  
//     // If no order data is found
//     if (!orderData) {
//       return (
//         <Box 
//           sx={{ 
//             display: 'flex', 
//             flexDirection: 'column',
//             justifyContent: 'center', 
//             alignItems: 'center', 
//             height: '100vh',
//             gap: 2
//           }}
//         >
//           <Typography variant="h5">
//             {error ? "Error Loading Order" : "Order not found"}
//           </Typography>
//           {error && (
//             <Typography color="error" sx={{ maxWidth: "600px", textAlign: "center", mb: 2 }}>
//               {error}
//             </Typography>
//           )}
//           <Button 
//             variant="contained" 
//             onClick={() => history.push('/orders')}
//             startIcon={<ArrowBackIcon />}
//           >
//             Back to Orders
//           </Button>
//         </Box>
//       );
//     }
  
//     // Extract polygon coordinates for the map
//     const polygonCoords = orderData.aoi_coordinates 
//       ? orderData.aoi_coordinates.map(coord => [coord.lat, coord.lng]) 
//       : [];
  
//     // Get order status steps
//     const orderStatusSteps = getOrderStatusSteps();
//     const currentStepIndex = getCurrentStepIndex();
//     const isTaskingOrder = orderData.order_type === 'tasking';
  
//     return (
//       <Box sx={{ 
//         position: 'fixed',
//         top: 48, // Adjust based on your header height
//         left: 0,
//         right: 0,
//         bottom: 0,
//         display: 'flex',
//         overflow: 'hidden'
//       }}>
//         {/* Left Panel - Order Info & Table */}
//         <Box sx={{ 
//           width: '60%', 
//           overflow: 'auto',
//           p: 2,
//           display: 'flex',
//           flexDirection: 'column'
//         }}>
//           {/* Back Button */}
//           <Button
//             startIcon={<ArrowBackIcon />}
//             sx={{
//               color: '#4287f5',
//               textTransform: 'none',
//               fontWeight: 500,
//               mb: 2,
//               alignSelf: 'flex-start'
//             }}
//             onClick={() => history.push('/orders')}
//           >
//             Back to Orders
//           </Button>
  
//           {/* Order Status Steps */}
//           <Box sx={{ 
//             display: 'flex', 
//             alignItems: 'center',
//             mb: 3,
//             mt: 1
//           }}>
//             {orderStatusSteps.map((status, index) => {
//               // Check if this is a final status that's not "Delivered"
//               const isNonDeliveredFinalStatus = orderData.status !== 'Delivered' && 
//                                               isFinalStatus(orderData.status) && 
//                                               index === orderStatusSteps.length - 1;
              
//               // Determine if this step is active
//               const isActive = index === currentStepIndex || 
//                              (isNonDeliveredFinalStatus && status === 'Delivered');
              
//               // Determine if this step is completed or in the past
//               const isPast = index < currentStepIndex;
              
//               // For final statuses that aren't "Delivered", we show them in place of the Delivered step
//               const displayStatus = (isNonDeliveredFinalStatus && index === orderStatusSteps.length - 1) 
//                                  ? orderData.status 
//                                  : status;
              
//               return (
//                 <React.Fragment key={status}>
//                   {/* Status Circle */}
//                   <Box 
//                     sx={{
//                       display: 'flex',
//                       flexDirection: 'column',
//                       alignItems: 'center',
//                       position: 'relative'
//                     }}
//                   >
//                     <Box
//                       sx={{
//                         width: 24,
//                         height: 24,
//                         borderRadius: '50%',
//                         bgcolor: isActive 
//                           ? (isNonDeliveredFinalStatus ? getStatusColor(orderData.status).color : '#4287f5')
//                           : (isPast ? '#4287f5' : '#e0e0e0'),
//                         display: 'flex',
//                         justifyContent: 'center',
//                         alignItems: 'center',
//                         color: 'white',
//                         fontWeight: 'bold',
//                         fontSize: 14,
//                         zIndex: 1
//                       }}
//                     >
//                       {index + 1}
//                     </Box>
//                     <Typography 
//                       sx={{ 
//                         mt: 1,
//                         fontSize: '12px',
//                         color: isActive 
//                           ? (isNonDeliveredFinalStatus ? getStatusColor(orderData.status).color : '#4287f5')
//                           : (isPast ? '#4287f5' : '#757575'),
//                         fontWeight: isActive ? 'bold' : 'normal',
//                         textTransform: 'capitalize'
//                       }}
//                     >
//                       {displayStatus}
//                     </Typography>
//                   </Box>
  
//                   {/* Connector Line (except after the last item) */}
//                   {index < orderStatusSteps.length - 1 && (
//                     <Box 
//                       sx={{ 
//                         flex: 1, 
//                         height: 2, 
//                         bgcolor: isPast ? '#4287f5' : '#e0e0e0',
//                         mx: 1
//                       }} 
//                     />
//                   )}
//                 </React.Fragment>
//               );
//             })}
//           </Box>
  
//           {/* Order Details Header */}
//           <Box sx={{ 
//             display: 'flex', 
//             justifyContent: 'space-between', 
//             alignItems: 'center',
//             mb: 2
//           }}>
//             <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
//               <Typography variant="h6" fontWeight={500}>
//                 Order ID: {orderId?.substring(0, 8) || 'N/A'}
//               </Typography>
              
//             <Chip 
//               label={orderData.status || 'Requested'} 
//               size="small"
//               sx={{ 
//                 bgcolor: getStatusColor(orderData.status).bg,
//                 color: getStatusColor(orderData.status).color,
//                 borderRadius: '4px',
//                 textTransform: 'capitalize'
//               }}
//             />
              
//               <Typography variant="body2" color="text.secondary">
//                 {formatDate(orderData.created_at || new Date())}
//               </Typography>
//             </Box>
            
//             {/* <Chip 
//               label={orderData.status || 'Requested'} 
//               size="small"
//               sx={{ 
//                 bgcolor: getStatusColor(orderData.status).bg,
//                 color: getStatusColor(orderData.status).color,
//                 borderRadius: '4px',
//                 textTransform: 'capitalize'
//               }}
//             /> */}
//           </Box>
  
//           {/* Data Products Tables - Grouped by Constellation */}
//           <Box sx={{ mb: 3 }}>
//             {Object.entries(groupedData).map(([constellation, images]) => (
//               <Card 
//                 key={constellation} 
//                 sx={{ 
//                   mb: 2, 
//                   boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.05)',
//                   overflow: 'visible'
//                 }}
//               >
//                 <CardHeader
//                   title={
//                     <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
//                       <Typography sx={{ fontWeight: 500, fontSize: '16px' }}>
//                         {`${constellation} (${images.length} product${images.length > 1 ? 's' : ''})`}
//                       </Typography>
//                       <IconButton
//                         onClick={() => toggleGroupExpansion(constellation)}
//                         aria-expanded={expandedGroups[constellation]}
//                         aria-label="show more"
//                         size="small"
//                       >
//                         {expandedGroups[constellation] ? 
//                           <KeyboardArrowUpIcon /> : 
//                           <KeyboardArrowDownIcon />
//                         }
//                       </IconButton>
//                     </Box>
//                   }
//                   sx={{ 
//                     bgcolor: '#f9f9f9', 
//                     py: 1,
//                     '& .MuiCardHeader-content': { width: '100%' }
//                   }}
//                 />
//                 <Collapse in={expandedGroups[constellation]} timeout="auto" unmountOnExit={false}>

//                   <CardContent sx={{ p: 0 }}>
//                     <TableContainer>
//                       <Table size="small">
//                         <TableHead sx={{ bgcolor: '#f5f5f5' }}>
//                           <TableRow>
//                             {!isTaskingOrder && <TableCell>DATA PRODUCT</TableCell>}
//                             {isTaskingOrder && <TableCell>CONSTELLATION</TableCell>}
//                             {isTaskingOrder && <TableCell>EST. TIME TO CAPTURE</TableCell>}
//                             {!isTaskingOrder && <TableCell>DATE OF CAPTURE</TableCell>}
//                             <TableCell>CLOUD COVER %</TableCell>
//                             <TableCell>RESOLUTION (m)</TableCell>
//                             <TableCell>OFF NADIR ANGLE (DEG)</TableCell>
//                             <TableCell>AOI COVERAGE %</TableCell>
//                             <TableCell>AREA (km<sup>2</sup>)</TableCell>
//                             <TableCell>ACTIONS</TableCell>
//                           </TableRow>
//                         </TableHead>
//                         <TableBody>
//                           {images.map((row, index) => (
//                             <TableRow key={row.id || index}>
//                               {!isTaskingOrder && (
//                                 <TableCell>
//                                   <TableRowImage 
//                                     imageId={row} 
//                                     fallbackUrl={row.preview_url} 
//                                   />
//                                 </TableCell>
//                               )}
//                               {isTaskingOrder && (
//                                 <TableCell>{row.satellite || '2025-02-24'}</TableCell>
//                               )}
//                               {isTaskingOrder && (
//                                 <TableCell>{"2025-03-14 to 2025-03-15"}</TableCell>
//                               )}
//                               {!isTaskingOrder && (
//                                 <TableCell>{formatDate(row.datetime || '2025-02-24')}</TableCell>
//                               )}
//                               <TableCell>
//                               {row.cloud_cover 
//                                   ? (typeof row.cloud_cover === 'string' && row.cloud_cover.includes('%') 
//                                       ? row.cloud_cover 
//                                       : `${row.cloud_cover}%`) 
//                                   : 'N/A'}
//                               </TableCell>

//                               <TableCell>{row.resolution || 'N/A'}m</TableCell>
//                               {!isTaskingOrder && (
//                                 <TableCell>0°</TableCell>
//                               )}
//                               {isTaskingOrder && (
//                                 <TableCell>0° - 5°</TableCell>
//                               )}
//                               <TableCell>
//                               {row.coverage_percentage 
//                                   ? (row.coverage_percentage.includes('%') ? row.coverage_percentage : `${row.coverage_percentage}%`) 
//                                   : '100 %'}
//                               </TableCell>
//                               <TableCell>{row.area || '274.97 sqkm'}</TableCell>
//                               <TableCell>
//   <Tooltip title="Toggle Preview Image">
//     <IconButton 
//       size="small" 
//       sx={{ color: '#2196f3' }}
//       onClick={() => {
//         // Toggle preview visibility for this specific image
//         const updatedImages = orderData.selected_images.map(img => 
//           img.id === row.id 
//             ? { ...img, previewVisible: !img.previewVisible } 
//             : img
//         );
//         setOrderData(prevData => ({
//           ...prevData,
//           selected_images: updatedImages
//         }));
//       }}
//     >
//       {row.previewVisible ? <VisibilityIcon fontSize="small" /> : <VisibilityOffIcon fontSize="small" />}
//     </IconButton>
//   </Tooltip>
//   <Tooltip title="Toggle GeoTIFF Rendering">
//     <IconButton 
//       size="small" 
//       sx={{ color: '#FF9800' }}
//       onClick={() => {
//         // Toggle GeoTIFF for this specific image
//         const updatedImages = orderData.selected_images.map(img => 
//           img.id === row.id 
//             ? { 
//                 ...img, 
//                 geoTIFFVisible: !img.geoTIFFVisible,
//                 previewVisible: false // Hide preview when GeoTIFF is shown
//               } 
//             : { ...img, geoTIFFVisible: false, previewVisible: false }
//         );
//         setOrderData(prevData => ({
//           ...prevData,
//           selected_images: updatedImages
//         }));
//       }}
//     >
//       <LayersIcon fontSize="small" />
//     </IconButton>
//   </Tooltip>
// </TableCell>
//                             </TableRow>
//                           ))}
//                         </TableBody>
//                       </Table>
//                     </TableContainer>
//                   </CardContent>
//                 </Collapse>
//               </Card>
//             ))}
//           </Box>
  
//           {/* Order Type Indicator */}
//           {/* <Box sx={{ mb: 3, mt: 1 }}>
//             <Chip 
//               label={`${orderData.order_type === 'tasking' ? 'Tasking' : 'Archival'} Order`}
//               sx={{ 
//                 bgcolor: orderData.order_type === 'tasking' ? '#EDE7F6' : '#E8F5E9',
//                 color: orderData.order_type === 'tasking' ? '#673AB7' : '#2E7D32',
//                 fontWeight: 'medium',
//                 px: 1
//               }}
//             />
//           </Box>*/}
//          </Box> 
  
//         {/* Right Panel - Map & Download */}
//         <Box sx={{ 
//           width: '40%',
//           position: 'relative',
//           overflow: 'hidden'
//         }}>
//           {/* Map */}
//           <MapView 
//             polygonCoords={polygonCoords}
//             orderData={orderData}
//             activeMapType={activeMapType}
//             setActiveMapType={setActiveMapType}
//             isTaskingOrder={isTaskingOrder}
//           />
    
//           {/* Download Section */}
//           <Box sx={{
//             position: 'absolute',
//             bottom: 0,
//             left: 0,
//             right: 0,
//             p: 2,
//             display: 'flex',
//             justifyContent: 'space-between',
//             zIndex: 1000,
//             backgroundColor: 'rgba(255, 255, 255, 0.7)',
//             backdropFilter: 'blur(4px)',
//             borderTop: '1px solid rgba(0, 0, 0, 0.1)'
//           }}>
//             <Button 
//               variant="contained" 
//               color="primary"
//               startIcon={<DownloadIcon />}
//               sx={{ 
//                 borderRadius: 1,
//                 boxShadow: 2
//               }}
//               disabled={orderData.status !== 'Delivered'}
//               onClick={() => {
//                 if (orderData.status === 'Delivered') {
//                   try {
//                     // Get all images from all constellation groups
//                     const allImages = [];
                    
//                     // Loop through all constellation groups and collect all images
//                     Object.keys(groupedData).forEach(constellation => {
//                       if (groupedData[constellation] && groupedData[constellation].length > 0) {
//                         groupedData[constellation].forEach(image => {
//                           allImages.push(image);
//                         });
//                       }
//                     });
                    
//                     if (allImages.length === 0) {
//                       setSnackbar({
//                         open: true,
//                         message: 'No images available to download',
//                         severity: 'warning'
//                       });
//                       return;
//                     }
                    
//                     // Update snackbar to indicate download started
//                     setSnackbar({
//                       open: true,
//                       message: `Starting download of ${allImages.length} images...`,
//                       severity: 'info'
//                     });
                    
//                     // Download each image sequentially
//                     let downloadedCount = 0;
                    
//                     // Function to download images sequentially
//                     const downloadNextImage = (index) => {
//                       if (index >= allImages.length) {
//                         // All downloads completed
//                         setSnackbar({
//                           open: true,
//                           message: `Successfully downloaded ${downloadedCount} of ${allImages.length} images`,
//                           severity: 'success'
//                         });
//                         return;
//                       }
                      
//                       const imageToDownload = allImages[index];
                      
//                       axios({
//                         url: IMAGE_URLS.downloadPreview(imageToDownload.id),
//                         method: 'GET',
//                         responseType: 'blob',
//                         headers: {
//                           'Authorization': `Bearer ${localStorage.getItem('token')}`
//                         }
//                       })
//                       .then(response => {
//                         const url = window.URL.createObjectURL(new Blob([response.data]));
//                         const link = document.createElement('a');
//                         link.href = url;
//                         link.download = `satellite-image-${imageToDownload.id}.png`;
//                         document.body.appendChild(link);
//                         link.click();
//                         document.body.removeChild(link);
//                         window.URL.revokeObjectURL(url);
                        
//                         downloadedCount++;
                        
//                         // Download next image after a short delay to prevent browser throttling
//                         setTimeout(() => {
//                           downloadNextImage(index + 1);
//                         }, 1000);
//                       })
//                       .catch(err => {
//                         console.error(`Download error for image ${imageToDownload.id}:`, err);
                        
//                         // Continue with next image despite error
//                         setTimeout(() => {
//                           downloadNextImage(index + 1);
//                         }, 1000);
//                       });
//                     };
                    
//                     // Start the download process
//                     downloadNextImage(0);
                    
//                   } catch (error) {
//                     console.error('Download error:', error);
//                     setSnackbar({
//                       open: true,
//                       message: 'Error initiating download: ' + error.message,
//                       severity: 'error'
//                     });
//                   }
//                 } else {
//                   setSnackbar({
//                     open: true,
//                     message: 'Download not available until order is Delivered.',
//                     severity: 'warning'
//                   });
//                 }
//               }}
//             >
//               Download
//             </Button>
//             <Button 
//               variant="contained" 
//               color="inherit"
//               endIcon={<InfoIcon />}
//               sx={{ 
//                 bgcolor: 'black',
//                 color: 'white',
//                 borderRadius: 1,
//                 '&:hover': {
//                   bgcolor: '#333'
//                 }
//               }}
//             >
//               View Details
//             </Button>
//           </Box>
//         </Box>
  
//         {/* Snackbar for notifications */}
//         <Snackbar 
//           open={snackbar.open} 
//           // autoHideDuration={6000} 
//           onClose={handleCloseSnackbar}
//           anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
//         >
//           <Alert 
//             onClose={handleCloseSnackbar} 
//             severity={snackbar.severity} 
//             variant="filled"
//             sx={{ width: '100%' }}
//           >
//             {snackbar.message}
//           </Alert>
//         </Snackbar>
//       </Box>
//     );
//   };
  
//   export default DataDeliveryPage;




import React, { useEffect, useState } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { 
  Box, 
  Typography, 
  Button, 
  Chip, 
  TableCell, 
  TableContainer, 
  TableHead, 
  TableRow,
  Table,
  TableBody,
  CircularProgress,
  IconButton,
  Alert,
  Snackbar,
  Collapse,
  Card,
  CardHeader,
  CardContent,
  Tooltip
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import DownloadIcon from '@mui/icons-material/Download';
import InfoIcon from '@mui/icons-material/Info';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import axios from 'axios';
import { MapView } from './DataDelivery-map-components';
import { TableRowImage, prefetchPreviews,formatDate, formatEstimatedTime,getPreviewUrl } from './DataDelivery-services-utils';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import LayersIcon from '@mui/icons-material/Layers';
import { CATALOG_URLS, IMAGE_URLS } from '../config/urls';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';


const DataDeliveryPage = () => {
    const { orderId } = useParams();
    const history = useHistory();
    const [orderData, setOrderData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [activeMapType, setActiveMapType] = useState('street');
    const [error, setError] = useState(null);
    const [snackbar, setSnackbar] = useState({
      open: false,
      message: '',
      severity: 'info'
    });
    // State to track which constellation groups are expanded
    const [expandedGroups, setExpandedGroups] = useState({});
    const [downloadAnchorEl, setDownloadAnchorEl] = useState(null);
const isDownloadMenuOpen = Boolean(downloadAnchorEl);

const handleDownloadClick = (event) => {
  setDownloadAnchorEl(event.currentTarget);
};

const handleDownloadClose = () => {
  setDownloadAnchorEl(null);
};

  
    // Helper to transform selected images for the table and group by constellation
    const getGroupedData = () => {
      const tableData = orderData?.selected_images || [];
      
      // Group images by satellite/constellation
      return tableData.reduce((acc, image) => {
        const constellation = image.satellite || 'Unknown';
        if (!acc[constellation]) {
          acc[constellation] = [];
        }
        acc[constellation].push(image);
        return acc;
      }, {});
    };
  
    // Compute the group data
    const groupedData = orderData ? getGroupedData() : {};
  
    // Initialize expanded groups when order data changes
    useEffect(() => {
      if (orderData?.selected_images?.length) {
        const constellations = {};
        orderData.selected_images.forEach(image => {
          const constellation = image.satellite || 'Unknown';
          constellations[constellation] = true; // Set all to expanded by default
        });
        
        if (Object.keys(constellations).length > 0) {
          setExpandedGroups(constellations);
        }
        
        // Pre-fetch all preview URLs for better user experience
        if (orderData.order_type === 'archival') {
          const imageIds = orderData.selected_images.map(img => img.id);
          // prefetchPreviews(imageIds).catch(err => console.error("Error pre-fetching previews:", err));
        }
      }
    }, [orderData]);
  
    useEffect(() => {
      const fetchOrderDetails = async () => {
        try {
          if (!orderId) {
            throw new Error('No order ID provided');
          }
          
          try {
            // Always use real API call to get the actual data
            const token = localStorage.getItem('token');
            const response = await axios.get(CATALOG_URLS.getOrder(orderId), {
              headers: { Authorization: `Bearer ${token}` }
            });
            
            // console.log("Fetched order data:", response.data); // Debug log
            setOrderData(response.data);
          } catch (error) {
            console.error("Error fetching order data:", error);
            setError(`Failed to fetch order data: ${error.message}`);
            setSnackbar({
              open: true,
              message: `Error: ${error.message}`,
              severity: 'error'
            });
          } finally {
            setIsLoading(false);
          }
        } catch (error) {
          console.error('Error fetching order details:', error);
          history.replace('/orders');
        }
      };
  
      fetchOrderDetails();
    }, [orderId, history]);
  
    // Function to determine the color for status chips
    const getStatusColor = (status) => {
      switch (status) {
        case 'requested':
          return { bg: '#DCF2FF', color: '#0288D1' };
        case 'accepted':
          return { bg: '#E3F3E3', color: '#4CAF50' };
        case 'processing':
          return { bg: '#FFF3E0', color: '#FF9800' };
        case 'captured':
          return { bg: '#E0E0E0', color: '#616161' };
        case 'Delivered':
          return { bg: '#E8EAF6', color: '#3F51B5' };
        case 'rejected':
          return { bg: '#FFEBEE', color: '#F44336' };
        case 'on-hold':
          return { bg: '#EDE7F6', color: '#673AB7' };
        case 'failed':
          return { bg: '#FFCDD2', color: '#D32F2F' };
        default:
          return { bg: '#F5F5F5', color: '#757575' };
      }
    };
    const downloadImages = (type = 'preview') => {
      const allImages = [];
    
      Object.keys(groupedData).forEach(constellation => {
        if (groupedData[constellation]?.length) {
          groupedData[constellation].forEach(image => {
            allImages.push(image);
          });
        }
      });
    
      if (allImages.length === 0) {
        setSnackbar({
          open: true,
          message: 'No images available to download',
          severity: 'warning'
        });
        return;
      }
    
      setSnackbar({
        open: true,
        message: `Starting download of ${allImages.length} ${type === 'preview' ? 'previews' : 'products'}...`,
        severity: 'info'
      });
    
      let downloadedCount = 0;
    
      const downloadNextImage = (index) => {
        if (index >= allImages.length) {
          setSnackbar({
            open: true,
            message: `Successfully downloaded ${downloadedCount} of ${allImages.length} ${type}s`,
            severity: 'success'
          });
          return;
        }
    
        const imageToDownload = allImages[index];
        const downloadUrl = type === 'preview'
          ? IMAGE_URLS.downloadPreview(imageToDownload.id)
          : IMAGE_URLS.downloadProduct(imageToDownload.id); // replace with actual endpoint
    
        axios({
          url: downloadUrl,
          method: 'GET',
          responseType: 'blob',
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          }
        })
        .then(response => {
          const blob = new Blob([response.data]);
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = `satellite-${type}-${imageToDownload.id}.${type === 'preview' ? 'png' : 'tif'}`; // adjust extension
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
    
          downloadedCount++;
          setTimeout(() => downloadNextImage(index + 1), 1000);
        })
        .catch(err => {
          console.error(`Download error for ${type} ${imageToDownload.id}:`, err);
          setTimeout(() => downloadNextImage(index + 1), 1000);
        });
      };
    
      downloadNextImage(0);
    };
    
  
    // Get order status steps based on order type
    const getOrderStatusSteps = () => {
      if (orderData?.order_type === 'tasking') {
        return ['requested', 'accepted', 'captured','processing', 'Delivered'];
      } else {
        // Default to archival
        return ['requested', 'accepted', 'processing', 'Delivered'];
      }
    };
  
    // Check if current status is a final status
    const isFinalStatus = (status) => {
      return ['Delivered', 'rejected', 'on-hold', 'failed'].includes(status);
    };
  
    // Get the current step index for the progress bar
    const getCurrentStepIndex = () => {
      const steps = getOrderStatusSteps();
      const currentStatus = orderData?.status || 'requested';
      
      // If current status is in the steps, return its index
      const statusIndex = steps.indexOf(currentStatus);
      if (statusIndex !== -1) {
        return statusIndex;
      }
      
      // If it's a final status but not Delivered, show as last step with different color
      if (isFinalStatus(currentStatus) && currentStatus !== 'Delivered') {
        return steps.length - 1;
      }
      
      // Default to requested (first step)
      return 0;
    };
  
    // Close snackbar
    const handleCloseSnackbar = () => {
      setSnackbar({...snackbar, open: false});
    };
  
    // Toggle expansion of a constellation group
    const toggleGroupExpansion = (constellation) => {
      setExpandedGroups(prevState => ({
        ...prevState,
        [constellation]: !prevState[constellation]
      }));
    };
  
    if (isLoading) {
      return (
        <Box 
          sx={{ 
            display: 'flex', 
            justifyContent: 'center', 
            alignItems: 'center', 
            height: '100vh' 
          }}
        >
          <CircularProgress />
        </Box>
      );
    }
  
    // If no order data is found
    if (!orderData) {
      return (
        <Box 
          sx={{ 
            display: 'flex', 
            flexDirection: 'column',
            justifyContent: 'center', 
            alignItems: 'center', 
            height: '100vh',
            gap: 2
          }}
        >
          <Typography variant="h5">
            {error ? "Error Loading Order" : "Order not found"}
          </Typography>
          {error && (
            <Typography color="error" sx={{ maxWidth: "600px", textAlign: "center", mb: 2 }}>
              {error}
            </Typography>
          )}
          <Button 
            variant="contained" 
            onClick={() => history.push('/orders')}
            startIcon={<ArrowBackIcon />}
          >
            Back to Orders
          </Button>
        </Box>
      );
    }
  
    // Extract polygon coordinates for the map
    const polygonCoords = orderData.aoi_coordinates 
      ? orderData.aoi_coordinates.map(coord => [coord.lat, coord.lng]) 
      : [];
  
    // Get order status steps
    const orderStatusSteps = getOrderStatusSteps();
    const currentStepIndex = getCurrentStepIndex();
    const isTaskingOrder = orderData.order_type === 'tasking';
  
    return (
      <Box sx={{ 
        position: 'fixed',
        top: 48, // Adjust based on your header height
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        overflow: 'hidden'
      }}>
        {/* Left Panel - Order Info & Table */}
        <Box sx={{ 
          width: '60%', 
          overflow: 'auto',
          p: 2,
          display: 'flex',
          flexDirection: 'column'
        }}>
          {/* Back Button */}
          <Button
            startIcon={<ArrowBackIcon />}
            sx={{
              color: '#4287f5',
              textTransform: 'none',
              fontWeight: 500,
              mb: 2,
              alignSelf: 'flex-start'
            }}
            onClick={() => history.push('/orders')}
          >
            Back to Orders
          </Button>
  
          {/* Order Status Steps */}
          <Box sx={{ 
            display: 'flex', 
            alignItems: 'center',
            mb: 3,
            mt: 1
          }}>
            {orderStatusSteps.map((status, index) => {
              // Check if this is a final status that's not "Delivered"
              const isNonDeliveredFinalStatus = orderData.status !== 'Delivered' && 
                                              isFinalStatus(orderData.status) && 
                                              index === orderStatusSteps.length - 1;
              
              // Determine if this step is active
              const isActive = index === currentStepIndex || 
                             (isNonDeliveredFinalStatus && status === 'Delivered');
              
              // Determine if this step is completed or in the past
              const isPast = index < currentStepIndex;
              
              // For final statuses that aren't "Delivered", we show them in place of the Delivered step
              const displayStatus = (isNonDeliveredFinalStatus && index === orderStatusSteps.length - 1) 
                                 ? orderData.status 
                                 : status;
              
              return (
                <React.Fragment key={status}>
                  {/* Status Circle */}
                  <Box 
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      position: 'relative'
                    }}
                  >
                    <Box
                      sx={{
                        width: 24,
                        height: 24,
                        borderRadius: '50%',
                        bgcolor: isActive 
                          ? (isNonDeliveredFinalStatus ? getStatusColor(orderData.status).color : '#4287f5')
                          : (isPast ? '#4287f5' : '#e0e0e0'),
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        color: 'white',
                        fontWeight: 'bold',
                        fontSize: 14,
                        zIndex: 1
                      }}
                    >
                      {index + 1}
                    </Box>
                    <Typography 
                      sx={{ 
                        mt: 1,
                        fontSize: '12px',
                        color: isActive 
                          ? (isNonDeliveredFinalStatus ? getStatusColor(orderData.status).color : '#4287f5')
                          : (isPast ? '#4287f5' : '#757575'),
                        fontWeight: isActive ? 'bold' : 'normal',
                        textTransform: 'capitalize'
                      }}
                    >
                      {displayStatus}
                    </Typography>
                  </Box>
  
                  {/* Connector Line (except after the last item) */}
                  {index < orderStatusSteps.length - 1 && (
                    <Box 
                      sx={{ 
                        flex: 1, 
                        height: 2, 
                        bgcolor: isPast ? '#4287f5' : '#e0e0e0',
                        mx: 1
                      }} 
                    />
                  )}
                </React.Fragment>
              );
            })}
          </Box>
  
          {/* Order Details Header */}
          <Box sx={{ 
            display: 'flex', 
            justifyContent: 'space-between', 
            alignItems: 'center',
            mb: 2
          }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <Typography variant="h6" fontWeight={500}>
                Order ID: {orderId?.substring(0, 8) || 'N/A'}
              </Typography>
              
            <Chip 
              label={orderData.status || 'Requested'} 
              size="small"
              sx={{ 
                bgcolor: getStatusColor(orderData.status).bg,
                color: getStatusColor(orderData.status).color,
                borderRadius: '4px',
                textTransform: 'capitalize'
              }}
            />
              
              <Typography variant="body2" color="text.secondary">
                {formatDate(orderData.created_at || new Date())}
              </Typography>
            </Box>
            
            {/* <Chip 
              label={orderData.status || 'Requested'} 
              size="small"
              sx={{ 
                bgcolor: getStatusColor(orderData.status).bg,
                color: getStatusColor(orderData.status).color,
                borderRadius: '4px',
                textTransform: 'capitalize'
              }}
            /> */}
          </Box>
  
          {/* Data Products Tables - Grouped by Constellation */}
          <Box sx={{ mb: 3 }}>
            {Object.entries(groupedData).map(([constellation, images]) => (
              <Card 
                key={constellation} 
                sx={{ 
                  mb: 2, 
                  boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.05)',
                  overflow: 'visible'
                }}
              >
                <CardHeader
                  title={
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                      <Typography sx={{ fontWeight: 500, fontSize: '16px' }}>
                        {`${constellation} (${images.length} product${images.length > 1 ? 's' : ''})`}
                      </Typography>
                      <IconButton
                        onClick={() => toggleGroupExpansion(constellation)}
                        aria-expanded={expandedGroups[constellation]}
                        aria-label="show more"
                        size="small"
                      >
                        {expandedGroups[constellation] ? 
                          <KeyboardArrowUpIcon /> : 
                          <KeyboardArrowDownIcon />
                        }
                      </IconButton>
                    </Box>
                  }
                  sx={{ 
                    bgcolor: '#f9f9f9', 
                    py: 1,
                    '& .MuiCardHeader-content': { width: '100%' }
                  }}
                />
                <Collapse in={expandedGroups[constellation]} timeout="auto" unmountOnExit={false}>

                  <CardContent sx={{ p: 0 }}>
                    <TableContainer>
                      <Table size="small">
                        <TableHead sx={{ bgcolor: '#f5f5f5' }}>
                          <TableRow>
                            {!isTaskingOrder && <TableCell>DATA PRODUCT</TableCell>}
                            {isTaskingOrder && <TableCell>CONSTELLATION</TableCell>}
                            {isTaskingOrder && <TableCell>EST. TIME TO CAPTURE</TableCell>}
                            {!isTaskingOrder && <TableCell>DATE OF CAPTURE</TableCell>}
                            <TableCell>CLOUD COVER %</TableCell>
                            <TableCell>RESOLUTION (m)</TableCell>
                            <TableCell>OFF NADIR ANGLE (DEG)</TableCell>
                            <TableCell>AOI COVERAGE %</TableCell>
                            <TableCell>AREA (km<sup>2</sup>)</TableCell>
                            <TableCell>ACTIONS</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {images.map((row, index) => (
                            <TableRow key={row.id || index}>
                              {!isTaskingOrder && (
                                <TableCell>
                                  <TableRowImage 
                                    imageId={row} 
                                    fallbackUrl={row.preview_url} 
                                  />
                                </TableCell>
                              )}
                              {isTaskingOrder && (
                                <TableCell>{row.satellite || '2025-02-24'}</TableCell>
                              )}
                              {isTaskingOrder && (
                                <TableCell>{"2025-03-14 to 2025-03-15"}</TableCell>
                              )}
                              {!isTaskingOrder && (
                                <TableCell>{formatDate(row.datetime || '2025-02-24')}</TableCell>
                              )}
                              <TableCell>
                              {row.cloud_cover 
                                  ? (typeof row.cloud_cover === 'string' && row.cloud_cover.includes('%') 
                                      ? row.cloud_cover 
                                      : `${row.cloud_cover}%`) 
                                  : 'N/A'}
                              </TableCell>

                              <TableCell>{row.resolution || 'N/A'}m</TableCell>
                              {!isTaskingOrder && (
                                <TableCell>0°</TableCell>
                              )}
                              {isTaskingOrder && (
                                <TableCell>0° - 5°</TableCell>
                              )}
                              <TableCell>
                              {row.coverage_percentage 
                                  ? (row.coverage_percentage.includes('%') ? row.coverage_percentage : `${row.coverage_percentage}%`) 
                                  : '100 %'}
                              </TableCell>
                              <TableCell>{row.area || '274.97 sqkm'}</TableCell>
                              <TableCell>
  <Tooltip title="Toggle Preview Image">
    <IconButton 
      size="small" 
      sx={{ color: '#2196f3' }}
      onClick={() => {
        // Toggle preview visibility for this specific image
        const updatedImages = orderData.selected_images.map(img => 
          img.id === row.id 
            ? { ...img, previewVisible: !img.previewVisible } 
            : img
        );
        setOrderData(prevData => ({
          ...prevData,
          selected_images: updatedImages
        }));
      }}
    >
      {row.previewVisible ? <VisibilityIcon fontSize="small" /> : <VisibilityOffIcon fontSize="small" />}
    </IconButton>
  </Tooltip>
  <Tooltip title="Toggle GeoTIFF Rendering">
    <IconButton 
      size="small" 
      sx={{ color: '#FF9800' }}
      onClick={() => {
        // Toggle GeoTIFF for this specific image
        const updatedImages = orderData.selected_images.map(img => 
          img.id === row.id 
            ? { 
                ...img, 
                geoTIFFVisible: !img.geoTIFFVisible,
                previewVisible: false // Hide preview when GeoTIFF is shown
              } 
            : { ...img, geoTIFFVisible: false, previewVisible: false }
        );
        setOrderData(prevData => ({
          ...prevData,
          selected_images: updatedImages
        }));
      }}
    >
      <LayersIcon fontSize="small" />
    </IconButton>
  </Tooltip>
</TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </CardContent>
                </Collapse>
              </Card>
            ))}
          </Box>
  
          {/* Order Type Indicator */}
          {/* <Box sx={{ mb: 3, mt: 1 }}>
            <Chip 
              label={`${orderData.order_type === 'tasking' ? 'Tasking' : 'Archival'} Order`}
              sx={{ 
                bgcolor: orderData.order_type === 'tasking' ? '#EDE7F6' : '#E8F5E9',
                color: orderData.order_type === 'tasking' ? '#673AB7' : '#2E7D32',
                fontWeight: 'medium',
                px: 1
              }}
            />
          </Box>*/}
         </Box> 
  
        {/* Right Panel - Map & Download */}
        <Box sx={{ 
          width: '40%',
          position: 'relative',
          overflow: 'hidden'
        }}>
          {/* Map */}
          <MapView 
            polygonCoords={polygonCoords}
            orderData={orderData}
            activeMapType={activeMapType}
            setActiveMapType={setActiveMapType}
            isTaskingOrder={isTaskingOrder}
          />
    
          {/* Download Section */}
          <Box sx={{
            position: 'absolute',
            bottom: 0,
            left: 0,
            right: 0,
            p: 2,
            display: 'flex',
            justifyContent: 'space-between',
            zIndex: 1000,
            backgroundColor: 'rgba(255, 255, 255, 0.7)',
            backdropFilter: 'blur(4px)',
            borderTop: '1px solid rgba(0, 0, 0, 0.1)'
          }}>
<Button 
  variant="contained" 
  color="primary"
  startIcon={<DownloadIcon />}
  sx={{ borderRadius: 1, boxShadow: 2 }}
  onClick={handleDownloadClick}
  disabled={orderData.status !== 'Delivered'}
>
  Download
</Button>
<Menu
  anchorEl={downloadAnchorEl}
  open={isDownloadMenuOpen}
  onClose={handleDownloadClose}
  anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
  transformOrigin={{ vertical: 'top', horizontal: 'left' }}
>
  <MenuItem
    onClick={() => {
      handleDownloadClose();
      // 👇 download PNG previews
      downloadImages('preview');
    }}
  >
    Download Previews (PNG)
  </MenuItem>
  <MenuItem
  onClick={() => {
    handleDownloadClose();
    downloadImages('product');
  }}
  disabled
>
  Download Data Products
</MenuItem>

</Menu>

            <Button 
              variant="contained" 
              color="inherit"
              endIcon={<InfoIcon />}
              sx={{ 
                bgcolor: 'black',
                color: 'white',
                borderRadius: 1,
                '&:hover': {
                  bgcolor: '#333'
                }
              }}
            >
              View Details
            </Button>
          </Box>
        </Box>
  
        {/* Snackbar for notifications */}
        <Snackbar 
          open={snackbar.open} 
          // autoHideDuration={6000} 
          onClose={handleCloseSnackbar}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        >
          <Alert 
            onClose={handleCloseSnackbar} 
            severity={snackbar.severity} 
            variant="filled"
            sx={{ width: '100%' }}
          >
            {snackbar.message}
          </Alert>
        </Snackbar>
      </Box>
    );
  };
  
  export default DataDeliveryPage;